import axios from "axios";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const errText = (err) => {
  const detail = err.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong. Please try again.";
};

export const downloadCsv = async (type, params = {}) => {
  const { data } = await adminApi.get("/admin/test/export", { params: { type, ...params }, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${type}-export.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
